module.exports = __webpack_public_path__ + "assets/img/desc-01-61dcc1b4.png";